import React from 'react';
import PropTypes from 'prop-types';
import Close from '@material-ui/icons/Close';
import { splitTextOnUrls } from 'helpers';

// Messages from the API can carry a url the athlete has to follow, such as the
// Next Gen membership link in a missing-membership error. Rendering the text as
// a single node would leave that url as unclickable plain text.
const renderText = (text) => {
  if (typeof text !== 'string') {
    return text;
  }

  const parts = splitTextOnUrls(text);

  if (parts.length < 2) {
    return text;
  }

  return parts.map((part) =>
    part.type === 'url' ? (
      <a
        key={part.start}
        href={part.value}
        target="_blank"
        rel="noopener noreferrer"
        className="notification-link"
      >
        {part.label || part.value}
      </a>
    ) : (
      part.value
    ),
  );
};

const Notification = ({
  type,
  text,
  showCloseButton,
  onClose,
  icon,
  style,
}) => {
  return !!text && text !== '' ? (
    <div style={style} className={`notification-container ${type}`}>
      {icon && <div className="notification-icon column">{icon}</div>}
      <div className="notification-content notification-column">
        <div className={`notification-${type}Message`}>{renderText(text)}</div>
      </div>
      {showCloseButton && (
        <div className="notification-close-icon">
          <button>
            <Close onClick={onClose} />
          </button>
        </div>
      )}
    </div>
  ) : null;
};

Notification.propTypes = {
  type: PropTypes.string,
  text: PropTypes.string,
  showCloseButton: PropTypes.bool,
  onClose: PropTypes.func,
  icon: PropTypes.node,
  style: PropTypes.object,
};

Notification.defaultProps = {
  type: 'error',
  text: 'error',
  icon: null,
  showCloseButton: false,
  onClose: () => {},
  style: {},
};

export default Notification;
